<script setup lang="ts">
import { RouterView } from 'vue-router';
import { onBeforeMount, onMounted, onBeforeUnmount, defineAsyncComponent } from 'vue';
import { addEventListener, clearEvent } from '@/utils/eventBus';
import { GitCodeLayoutEmitter } from 'vue-layout-gitcode';
import debounce from 'lodash/debounce';
import cookie from 'js-cookie';
import { useGlobalInfoStore } from '@/stores/Global';
import dayjs from 'dayjs';
import { useHead } from '@/utils/hooks/useHead';
import { bindPointInviteCode } from '@/utils/hooks/useInviteCode';
import { setTheme } from '@/themes/index';
import { setEnv } from './env';
import forbiddenModalStore from '@/components/ForbiddenModal/store';
import { storeToRefs } from 'pinia';
import { handleExternalLink } from '@/utils/externalLink';
import request from '@/utils/request';
import { useAccount } from '@/utils/hooks/useAccount';
import { useLogin } from 'vue-layout-gitcode';
import 'vue-layout-gitcode/style.css';
const ForbiddenModal = defineAsyncComponent(() => import('@/components/ForbiddenModal/index.vue'));
const globalInfo = useGlobalInfoStore();
const { visible } = storeToRefs(forbiddenModalStore());
const { createMetaTag } = useHead();
const { login } = useLogin(request);
const { RecordInfo } = useAccount();

// 登录成功
const loginSuccess = (userInfo) => {
  RecordInfo(userInfo);
};
createMetaTag();
const checkoutFirstTime = () => {
  const uuid = cookie.get('uuid_tt_dd');
  const firstTime = cookie.get('gitcode_first_time');
  if (uuid && !firstTime) {
    const expireDate = new Date(`${dayjs().year() + 2}-01-01 00:00:00`);
    const expirationUTC = new Date(
      Date.UTC(
        expireDate.getFullYear(),
        expireDate.getMonth(),
        expireDate.getDate(),
        expireDate.getHours(),
        expireDate.getMinutes(),
        expireDate.getSeconds()
      )
    );
    const domainMatch = (location.host.match(/(gitcode..+)/) || []) as string[];
    cookie.set('gitcode_first_time', dayjs().format('YYYY-MM-DD HH:mm:ss'), {
      expires: expirationUTC,
      domain: domainMatch[1]
    });
  }
};

onBeforeMount(() => {
  // href有成长中心的积分邀请码则绑定
  bindPointInviteCode();
});

const updateHeaderStyle = (eventPayload: any) => {
  const { visible } = eventPayload;
  if (visible) {
    document.querySelector('.g-header')?.classList.add('!bg-transparent');
  } else {
    document.querySelector('.g-header')?.classList.remove('!bg-transparent');
  }
};

onMounted(() => {
  handleExternalLink();
  addEventListener('updateHeader', (options) => {
    const { eventPayload } = options;
    updateHeaderStyle(eventPayload);
  });
  checkoutFirstTime();
  // 监听消息事件 updateNotice， updateNoticeCount就不使用默认的拦截了 单独发送事件 不然会出现循序监听
  addEventListener(
    'updateNotice',
    debounce(() => {
      GitCodeLayoutEmitter.emit('updateNotice');
    }, 500)
  );
  // 消息更新没有那么及时，需要延迟500ms 更新消息数量
  addEventListener(
    'updateNoticeCount',
    debounce(() => {
      GitCodeLayoutEmitter.emit('updateNoticeCount');
    }, 500)
  );
  // 监听微服务发送过来的，eventBus的登录相关
  addEventListener('logout', (options) => {
    GitCodeLayoutEmitter.emit('logout', options);
  });
  addEventListener('login', (options) => {
    GitCodeLayoutEmitter.emit('login', options);
  });
  // 系统消息更新邮箱信息
  addEventListener('notice', (options) => {
    GitCodeLayoutEmitter.emit('notice', options);
  });
  addEventListener('needLogin', (options) => {
    login(options, loginSuccess, true);
  });
  // 添加主题
  setTheme();
  setEnv();
});

onBeforeUnmount(() => {
  clearEvent();
  window.removeEventListener('message', () => {});
});
</script>

<template>
  <RouterView :class="`g-theme-${globalInfo.globalTheme}`" />
  <ForbiddenModal v-if="visible" />
</template>

<style lang="scss">
.global-notification {
  &-mobile {
    .devui-notification {
      right: 15px;
      left: 15px;
      width: #{calc(100vw - 30px)};
      top: 60px;
      &__title {
        padding: 0;
      }
    }
    .devui-notification-item-container {
      background: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      padding: 15px;
      opacity: 1;
      .devui-notification__item {
        padding: 0;
      }
    }
  }
  &-pc {
    .devui-notification {
      width: 296px;
      right: 22px;
      top: 60px;
      &__title {
        padding: 0;
      }
    }
    .devui-notification-item-container {
      background: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      padding: 22px;
      opacity: 1;
      .devui-notification__item {
        padding: 0;
      }
    }
  }
  .devui-notification__message {
    margin-left: 0;
  }
  .icon-close {
    font-size: 0 !important;
    &:before {
      content: '';
    }
  }
}
</style>
